export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11516.9ef85330.jpg";